'use client'

import React from 'react'
import styles from './ArticleDetailHeadInfos.module.scss'
import AudioBtn from '@/elements/widgets/Article/ArticleDetailHead/Infos/AudioBtn'
import Publication from '@/elements/widgets/Article/ArticleDetailHead/Infos/Publication'
import AudioPlayer from '@/components/AudioPlayer/AudioPlayer'
import ShareBtn from '@/components/ShareBtn/ShareBtn'

const ArticleDetailInfos = ({ item }: { item: any }) => {
  const [toggle, setToggle] = React.useState(false)
  return (
    <div className={styles.container}>
      {item.items.map((item: any, index: number) => {
        return (
          <React.Fragment key={index}>
            <div className={styles.infos}>
              <div className={styles['left-block']}>
                <AudioBtn item={item} onClickAction={() => setToggle(!toggle)} />
                {!item?.model?.audio && <Publication item={item} />}
              </div>
              <div className={styles['right-block']}>
                <ShareBtn url={globalThis?.window?.location?.href} />
              </div>
            </div>
            {item.model.audio && (
              <AudioPlayer
                audioUrl={item.model.audio.urls.mp3 ?? ''}
                audioDur={item.model.audio.duration ?? ''}
                id={item.model.audio.id}
                title={item.model.audio.kicker + ': ' + item.model.audio.headline}
                mediaType="voice_player"
                section={item.model.audio.homeSection}
                show={toggle}
              />
            )}
            {item.model.audio && <Publication item={item} />}
          </React.Fragment>
        )
      })}
    </div>
  )
}

export default ArticleDetailInfos
